export default __webpack_public_path__ + "static/media/faze.40940d94.png";